/**
 * <kk-product-reviews> — makes an in-page link ("#reviews") scroll smoothly to its target, leaving room for the
 * sticky header. Any other link (another page, another section's URL) is followed normally.
 */
class KKProductReviews extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  #onClick(event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link || link.getAttribute('href') === '#') return;
    const target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
    if (!target) return;
    event.preventDefault();
    const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kk-header-height')) || 0;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.scrollY - header - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
    history.replaceState(null, '', link.getAttribute('href'));
  }
}

if (!customElements.get('kk-product-reviews')) {
  customElements.define('kk-product-reviews', KKProductReviews);
}
